module.exports = __webpack_public_path__ + "media/images/icons/tw-be729f36ec9c9b6abaf3ff872faeef64.svg";